<template>
  <div class="child-search">
    <div v-if="children && children.length > 0" class="row">
      <div
          v-for="child in filter(children)"
          :key="child.id"
          class="col-12"
      >
        <div class="row child d-flex align-items-center">
          <div class="col-4 col-sm-2">
            <span v-on:click="selectChild(child, '/children/' + child.id)">
              <child-thumbnail :key="child.id" :child="child"></child-thumbnail>
            </span>
          </div>
          <div class="col-8 col-sm-6">
            <span v-on:click="selectChild(child, '/children/' + child.id)">
              <h3>{{ child.first_name }}</h3>
              <p style="margin-bottom: 0">{{ child.last_name_suffix }} {{ child.last_name }}</p>
            </span>
          </div>
          <div class="col-3 col-sm-1">
            <span v-on:click="selectChild(child, '/children/' + child.id)">
              <icon name="child"></icon>
            </span>
          </div>
          <div class="col-3 col-sm-1" v-if="isAuthorized('planning', 'planning', 'view')">
            <span
                v-on:click="selectChild(child, '/children/' + child.id + '/planning')"
            >
              <icon name="planning"></icon>
            </span>
          </div>
          <div class="col-3 col-sm-1" v-if="isAuthorized('communication', 'activities', 'view')">
            <span
                v-on:click="selectChild(child, '/children/' + child.id + '/activities')"
            >
              <icon name="activities"></icon>
            </span>
          </div>
          <div class="col-3 col-sm-1" v-if="isAuthorized('communication', 'messages', 'view')">>
            <span
                v-on:click="selectChild(child, '/chat')"
            >
              <icon name="chat"></icon>
            </span>
          </div>
          <div class="col-12">
            <hr>
          </div>
        </div>
      </div>
    </div>
    <div
        v-else
        class="row"
    >
      <div class="col-12">
        <p class="no-children text-center">Geen kinderen</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import ChildThumbnail from '@/components/Child-Thumbnail'
export default {
  name: 'child-search',
  components: {
    Icon,
    ChildThumbnail
  },
  computed: {
    showSearch () {
      return this.$store.getters.showSearch
    }
  },
  watch: {
    showSearch (bool) {
      if (bool === false) {
        this.query = ''
      }
    }
  },
  data () {
    return {
      query: ''
    }
  },
  created () {
    this.$store.dispatch('getChildren')
  },
  methods: {
    filter (children) {
      if (this.query.length < 1) {
        return children
      } else {
        var query = this.query.toLowerCase()
        var self = this
        return this.$lodash().filter(children, function (child) {
          return self.$lodash().includes(child.first_name.toLowerCase(), query)
        })
      }
    },
    sort (children, by) {
      by = by || 'first_name'
      return this.$lodash().sortBy(children, by, 'asc')
    },
    selectChild (child, redirectUrl) {
      if (child.id_child) {
        child.id = child.id_child
      }
      if (child.id) {
        child.id_child = child.id
      }
      this.$store.commit('SET_SELECTED_CHILD', child)
      this.$store.commit('SET_SHOW_SEARCH', false)
      this.closeMainNavbarIfNeeded()
      this.$router.push(redirectUrl)
    }
  }
}
</script>

<style scoped>
  a {
    text-decoration: none;
    color: #666;
  }
  .child-search {
    padding-bottom: 100px;
  }
</style>
